<template>
  <v-footer id="dashboard-core-footer">
    <v-container>
      <span class="body-2 font-weight-light pt-6 pt-md-0">
          <center>  {{powered_by}} &nbsp; &nbsp;&copy; {{year}}</center>
      </span>
    </v-container>
  </v-footer>
</template>

<script>
import moment from 'moment'
export default {
  name: "DashboardCoreFooter",
  data(){
    return{
      year: moment().format("YYYY"),
      powered_by : process.env.VUE_APP_COUNTRY=='RWANDA'?  'Rura - Inspiring Development' : 'Powered by Kensrin: GPS Tracking solutions providers.'
    }
  }
  
};
</script>

<style lang="sass">
#dashboard-core-footer
  a
    font-size: .825rem
    font-weight: 500
    text-decoration: none
    text-transform: uppercase
</style>
